// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2bmcs","dragIcon":"SortableItem_dragIcon__37gmf","disabled":"SortableItem_disabled__2jq8l"};